import {ProcessSingletonTaskSchemaName} from 'graphql-client/__generated/graphqlGlobalTypes';
import {makeReactContext} from 'lib/makeReactContext';

import {ProcessTaskSchemaGraphQL} from '../../../../../graphql-fragments/processes/schemas/__generated/ProcessTaskSchemaGraphQL';

export type SingletonTaskSchemasByName = Partial<
  Record<ProcessSingletonTaskSchemaName, ProcessTaskSchemaGraphQL>
>;

export const SingletonTaskSchemasContext = makeReactContext<SingletonTaskSchemasByName>(
  () => ({}),
  'SingletonTaskSchemasContext'
);
